document.addEventListener("DOMContentLoaded", function () {
  const input = document.querySelector('input[placeholder*="Search"]');
  if (!input) return;

  const words = [
    "Blazers & Co ord sets",
    "Sarees",
    "Kaftans",
    "Capes & Blouse sets",
  ];

  const baseText = "Search for ";
  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;

  function typeEffect() {
    const currentWord = words[wordIndex];

    if (!isDeleting) {
      input.placeholder =
        baseText + currentWord.substring(0, charIndex + 1);
      charIndex++;

      if (charIndex === currentWord.length) {
        setTimeout(() => (isDeleting = true), 1200);
      }
    } else {
      input.placeholder =
        baseText + currentWord.substring(0, charIndex - 1);
      charIndex--;

      if (charIndex === 0) {
        isDeleting = false;
        wordIndex = (wordIndex + 1) % words.length;
      }
    }

    setTimeout(typeEffect, isDeleting ? 60 : 120);
  }

  typeEffect();
});
